import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import Language from "@serie3/freelancesplaceapi/Domain/Profile/Language";
import { btn, btnHoverStyle } from "./buttonStyles";

const AddLanguageButton = ({ formik, setEditLanguage, setShowLanguageForm }) => {
  return (
    <div style={{ display: "flex", justifyContent: "flex-end" }}>
      <style>{btnHoverStyle}</style>
      <button
        className="btn-modern"
        style={{ ...btn.base, ...btn.success }}
        onClick={() => {
          const arrayLength = formik.values.languages.length;
          if (arrayLength > 0) {
            const lastLanguage = formik.values.languages[arrayLength - 1];
            if (
              typeof lastLanguage !== "undefined" &&
              (typeof lastLanguage.name !== "undefined" ||
                typeof lastLanguage.level !== "undefined")
            ) {
              formik.values.languages.push(Language);
            }
          } else {
            formik.values.languages.push(Language);
          }
          setEditLanguage(null);
          setShowLanguageForm(true);
        }}
      >
        <FontAwesomeIcon icon={faAdd} />
        Add
      </button>
    </div>
  );
};

export default AddLanguageButton;
